(ns bedrock-ui.http.interceptors
  (:require [ajax.core :refer [to-interceptor]]
            [bedrock-ui.http.core :as http]
            [bedrock-ui.sentry.handlers]
            [cognitect.transit :as transit]))

(def ^:private reader
  (transit/reader :json))

(def ^:private reportable-error?
  (some-fn http/reportable-client-errors
           http/reportable-server-errors))

(defn make-error-logging-interceptor
  [log]
  (to-interceptor
   {:name "log errors to sentry"
    :response (fn [response]
                (when (reportable-error? (ajax.protocols/-status response))
                  (let [body (cond->> (ajax.protocols/-body response)
                               (= "application/transit+json"
                                  (ajax.protocols/-get-response-header response "content-type"))
                               (transit/read reader))]
                    (log {:message "XHR request failed" :body body})))
                response)}))
